import { useTranslation } from "react-i18next";

import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { useEffect, useState } from "react";

type valueOfMovableType = {
  trans_key?: string;
  minimum: number;
  maximum: number | null;
};
export const ValueOfMovable = ({
  setResponseMovableIncome,
  valueOfMovable
}: {
  setResponseMovableIncome: (mi: valueOfMovableType) => void;
  valueOfMovable: valueOfMovableType;
}) => {
  const { t } = useTranslation(["pass"]);
  const valueOfMovables = [
    {
      id: 1,
      trans_key: "less_20000",
      minimum: 0,
      maximum: 20000
    },
    {
      id: 2,

      trans_key: "between_20000_and_ 100000",
      minimum: 20000,
      maximum: 100000
    },
    {
      id: 3,

      trans_key: "between_100000_and_250000",
      minimum: 100000,
      maximum: 250000
    },
    {
      id: 4,

      trans_key: "between_250000_and_500000",
      minimum: 250000,
      maximum: 500000
    },
    {
      id: 5,

      trans_key: "between_500000_and_1000000",
      minimum: 500000,
      maximum: 1000000
    },
    {
      id: 6,

      trans_key: "between_1000000_and_5000000",
      minimum: 1000000,
      maximum: 5000000
    },
    {
      id: 7,

      trans_key: "more_5000000",
      minimum: 5000000,
      maximum: null
    }
  ];
  const [valueDropDown, setValueDropDown] = useState<string>(
    valueOfMovables.find(
      (mi) =>
        valueOfMovable &&
        mi.minimum.toString() === valueOfMovable.minimum?.toString() &&
        mi.maximum?.toString() === valueOfMovable.maximum?.toString()
    )?.trans_key as string
  );
  useEffect(() => {
    const initKey = valueOfMovables.find((cs) => {
      return cs.maximum === valueOfMovable?.maximum && cs.minimum === valueOfMovable?.minimum;
    });

    setValueDropDown(initKey?.trans_key as string);
  }, [valueOfMovable]);

  return (
    <>
      <div className="my-4 mt-4 w-full">
        <Dropdown
          onChange={(item) => {
            const mIncome = valueOfMovables.find(
              (mi) =>
                t(
                  "olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.ValueOfMovable.responses." +
                    mi.trans_key
                ) === (item.value as string)
            );
            if (!valueOfMovable || mIncome?.trans_key !== valueOfMovable.trans_key)
              if (mIncome) setResponseMovableIncome(mIncome);
          }}
          required={true}
          value={valueDropDown}
          className="w-full"
          search={true}
          fromQuiz={true}
          items={valueOfMovables.map((mi) => {
            return {
              key: mi.trans_key,
              value: t(
                "olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.ValueOfMovable.responses." +
                  mi.trans_key
              )
            };
          })}
        />
      </div>
    </>
  );
};
